import React from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import TablePagination from "@mui/material/TablePagination";

import {
  formatMonetary,
  timeStampToDate,
  formatUpperCase,
} from "../../../../utils/formats";
import Table from "../../subcomponents/Table";
import { Label, Separator, Text } from "../styles";

const style = {
  justify: "center",
};

const nfColumns = [
  { id: "codigoEmpresa", name: "Empresa", style },
  { id: "numero", name: "Número", style },
  { id: "serie", name: "Série", style },
  { id: "dataEmissao", name: "Data emissão", render: timeStampToDate, style },
  { id: "especieNotaFiscalDescricao", name: "Espécie", style },
  { id: "tipoDocumentoDescricao", name: "Tp Doc", style },
  {
    id: "situacaoDescricao",
    name: "Situação NF",
    render: formatUpperCase,
    style,
  },
  { id: "codigoPedido", name: "Pedido", style },
  { id: "ordemServico", name: "O.S.", render: formatUpperCase, style },
  { id: "nomePessoaVendedor", name: "Vendedor", style },
  { id: "valorTotal", name: "Total NF", render: formatMonetary, style },
];

const nfTotalColumns = [
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  {
    custom: true,
    render: () => (
      <Text align="end" textColor="#747576">
        Total NF
      </Text>
    ),
  },
  { id: "id", render: formatMonetary, style },
];

const vendaDiretaColumns = [
  { id: "empresaId", name: "Empresa", render: formatUpperCase, style },
  { id: "pedidoId", name: "Pedido", style },
  {
    id: "dataAprovacao",
    name: "Data Aprovação",
    render: timeStampToDate,
    style,
  },
  {
    id: "descricaoSituacaoPedido",
    name: "Situação",
    render: formatUpperCase,
    style,
  },
  { id: "numeroChassi", name: "Chassi", style },
  { id: "pessoaVendedorId", name: "Cód. Ven.", style },
  { id: "pessoaVendedorNome", name: "Vendedor", style },
  { id: "valorTotal", name: "Valor Total", render: formatMonetary, style },
];

const vendaDiretaTotalColumns = [
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  { custom: true },
  {
    custom: true,
    render: () => (
      <Text align="end" textColor="#747576">
        Total Venda Dir.
      </Text>
    ),
  },
  { id: "id", render: formatMonetary, style },
];

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

const HistoricoVendasSection = (props) => {
  const {
    notaFiscal,
    notaFiscalLoading,
    notaFiscalTotal,
    pageNotaFiscal,
    setFiltersNotaFiscal,
    filtersNotaFiscal,
    vendaDireta,
    vendaDiretaLoading,
    vendaDiretaTotal,
    pageVendaDireta,
    setFiltersVendaDireta,
    filtersVendaDireta,
  } = props;

  const classes = useStyles();

  const handleChangePageNotaFiscal = (p, newPage) => {
    setFiltersNotaFiscal({
      ...filtersNotaFiscal,
      pageable: {
        ...filtersNotaFiscal.pageable,
        page: newPage,
      },
    });
  };

  const handleChangePageVendaDireta = (p, newPage) => {
    setFiltersVendaDireta({
      ...filtersVendaDireta,
      pageable: {
        ...filtersVendaDireta.pageable,
        page: newPage,
      },
    });
  };

  return (
    <>
      <Label>Nota Fiscal</Label>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={notaFiscalLoading}
            noDataMessage="SEM DADOS."
            entries={notaFiscal}
            total={notaFiscalTotal}
            columns={nfColumns}
            totalColumns={nfTotalColumns}
          />
        </Grid>
        <Grid item xs={12}>
          <RodaPe>
            <TablePagination
              component="div"
              classes={{
                toolbar: classes.toolbar,
                caption: classes.caption,
              }}
              count={pageNotaFiscal?.total ?? 0}
              page={pageNotaFiscal?.pageable?.page ?? 0}
              labelDisplayedRows={({ from, to, count }) =>
                `${from} - ${to} de ${count}`
              }
              onPageChange={handleChangePageNotaFiscal}
              rowsPerPageOptions={[]}
              rowsPerPage={pageNotaFiscal?.pageable?.size ?? 0}
            />
          </RodaPe>
        </Grid>
      </Grid>
      <Separator />
      <Label>Venda Direta</Label>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Table
            loading={vendaDiretaLoading}
            noDataMessage="SEM DADOS."
            entries={vendaDireta}
            total={vendaDiretaTotal}
            columns={vendaDiretaColumns}
            totalColumns={vendaDiretaTotalColumns}
          />
        </Grid>
        <Grid item xs={12}>
          <RodaPe>
            <TablePagination
              component="div"
              classes={{
                toolbar: classes.toolbar,
                caption: classes.caption,
              }}
              count={pageVendaDireta.total}
              page={pageVendaDireta.pageable.page || 0}
              labelDisplayedRows={({ from, to, count }) =>
                `${from} - ${to} de ${count}`
              }
              onPageChange={handleChangePageVendaDireta}
              rowsPerPageOptions={[]}
              rowsPerPage={pageVendaDireta.pageable.size}
            />
          </RodaPe>
        </Grid>
      </Grid>
    </>
  );
};

export const RodaPe = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export default HistoricoVendasSection;
